import React from 'react';
import AboutMe from './AboutMe';
import Publications from './Publications';
import Research from './Research';
import Education from './Education';
import Reading from './Reading';
import Map from './Map';
import Awards from './Awards';
import Review from './Review';

export default function Section(props) {
    console.log(props);
    if (props.sectionId === 'aboutMe')
        return <AboutMe />
    else if (props.sectionId === 'publications')
        return <Publications />
    else if (props.sectionId === 'research')
        return <Research />
    else if (props.sectionId === 'education')
        return <Education />
    else if (props.sectionId === 'reading')
        return <Reading />
    else if (props.sectionId === 'awards')
        return <Awards />
    else if (props.sectionId === 'review')
        return <Review />
    else if (props.sectionId === 'map')
        return <Map />
}

// export default withRouter(Section);


// WEBPACK FOOTER //
// ./src/components/Section.jsx